<template>
  <div>
    <div v-if="loading" class="loader">
      <bb-spinner/>
    </div>
    <pay-back
      v-if="visible"
      :visible="visible"
      is-mobile-app
    />
  </div>
</template>

<script>
import { mapActions } from 'pinia'
import { useLoanStore } from '@loan/store/loanStore'
import PayBack from '@credit-card/views/PayBack.vue'

export default {
  name: 'credit-card-pay-back-page',
  components: { PayBack },
  data () {
    return {
      card: null,
      visible: false,
      loading: false
    }
  },
  async created () {
    try {
      this.loading = true
      await this.getContract()

      this.visible = true
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions(useLoanStore, ['getContract']),
    onModalClosed () {
      this.visible = false
    }
  }
}
</script>
